import { AuthUser } from 'src/@types/auth';
import { NewResponse, PersonalInfo, newPassword } from 'src/@types/lms/personal';
import { Role } from '../../@types/lms/roles';
import API from '../api';
import { APPICONFIG } from '../apiconfig';

class APIPERSONAL extends API {
  async getLoginRoles(token: string): Promise<Role[]> {
    let data: Role[] = [
      {
        id: '',
        name: '',
        description: '',
        enabled: true,
      },
    ];
    data.splice(0, 1);
    this.data = {};
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.PERSONAL.GETROLES;
    let dataResponse = await this.makeLoginGetRequest(token);
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      for (let i = 0; i < dataResponse.data.length; i++) {
        data.push({
          id: dataResponse.data[i].id,
          name: dataResponse.data[i].roleName,
          description: dataResponse.data[i].description,
          enabled: dataResponse.data[i].enabled,
        });
      }
    }
    return data;
  }

  async getUserRoles(): Promise<Role[]> {
    let data: Role[] = [
      {
        id: '',
        name: '',
        description: '',
        enabled: true,
      },
    ];
    data.splice(0, 1);
    this.data = {};
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.PERSONAL.GETROLES;
    let dataResponse = await this.makeGetRequest();
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      for (let i = 0; i < dataResponse.data.length; i++) {
        data.push({
          id: dataResponse.data[i].id,
          name: dataResponse.data[i].roleName,
          description: dataResponse.data[i].description,
          enabled: dataResponse.data[i].enabled,
        });
      }
    }
    return data;
  }

  async getPersonalInfo(token: string): Promise<AuthUser> {
    let data = {
      id: '',
      userName: '',
      firstName: '',
      lastName: '',
      email: '',
      imageUrl: '',
      enabled: true,
    };
    this.data = {};
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.PERSONAL.GETPROFILE;
    let dataResponse = await this.makeLoginGetRequest(token);
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      data = dataResponse;
    }
    return data;
  }

  async updatePersonalInfo(info: PersonalInfo): Promise<NewResponse> {
    let response = {
      success: false,
      errorMessage: '',
    };
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.PERSONAL.EDITPROFILE;
    this.data = info;
    let dataResponse = await this.makePutRequest();
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      response.success = true;
    } else {
      response.success = false;
      response.errorMessage = dataResponse.messages ? dataResponse.messages[0] : dataResponse.exception ? dataResponse.exception : "Unexpected error (" + dataResponse.status + ")";
    }
    return response;
  }

  async changePassword(info: newPassword): Promise<NewResponse> {
    let response = {
      success: false,
      errorMessage: '',
    };
    this.url = APPICONFIG.API_URL + APPICONFIG.API_PATHS.PERSONAL.CHANGEPASSWORD;
    this.data = info;
    let dataResponse = await this.makePutRequest();
    if (dataResponse.status === APPICONFIG.API_RESPONSE_HEADER.OK) {
      response.success = true;
    } else {
      response.success = false;
      response.errorMessage = dataResponse.messages ? dataResponse.messages[0] : dataResponse.exception ? dataResponse.exception : "Unexpected error (" + dataResponse.status + ")";
    }
    return response;
  }
}

export default APIPERSONAL;
